<template>
  <div class="bg-white">
    <button
      type="button"
      class="bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900 group w-full flex items-center px-4 py-5 sm:px-6 text-left text-sm font-medium focus:outline-none"
      @click="toggle"
    >
      <svg
        class="mr-2 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        :class="[show ? 'text-gray-400 rotate-90' : 'text-gray-300']"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
      </svg>
      {{ title }}
    </button>
    <div v-if="show" class="px-4 py-5 sm:p-6">
      <slot :collapse="collapse" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Title',
    },
    expandedByDefault: Boolean,
  },
  data() {
    return {
      show: this.expandedByDefault,
    };
  },
  methods: {
    setShow(show = true) {
      this.show = show;
    },
    toggle() {
      if (this.show) {
        this.collapse();
      } else {
        this.expand();
      }
    },
    expand() {
      this.setShow();
      this.$emit('expand');
    },
    collapse() {
      this.setShow(false);
      this.$emit('collapse');
    },
  },
};
</script>
